/**
 * ヘッダー用モジュール。
 * @module app/view/Header
 */
define([
    'module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom',
    'dojo/dom-style',
    'dojo/topic',
    'dojo/text!./templates/TrainingHeader.html',
    'idis/control/Locator',
    'idis/model/UserInfo',
    'idis/view/_IdisWidgetBase',
    // 以下、変数で受けないモジュール
    'idis/view/dialog/IdisDialog',
    'idis/view/form/MunicipalitySelectForm',
    'app/view/PopupAlert',
    'dijit/form/Select',
    'idis/view/form/GeocodingForm',
    'dijit/form/Form',
    'app/view/Menu'
], function (module, declare, lang, dom, domStyle, topic, template, Locator, UserInfo, _IdisWidgetBase) {
    /**
     * ヘッダー用オブジェクト
     * @class Header
     */
    return declare(module.id.replace(/\//g, '.'), _IdisWidgetBase, /** @lends app/view/Header~Header# */ {
        // テンプレート文字列
        templateString: template,

        // ルート要素のCSSクラス
        baseClass: 'index-Header',

        // DOMを構築する
        buildRendering: function() {
            this.inherited(arguments);

            var userName = UserInfo.getName();
            if (userName && userName.length > 15) {
                userName = userName.substring(0, 15) + '...';
            }
            this.loginIdNode.innerHTML = userName;

            var html = [];
            // ログアウト・フォーム
            html.push('<form method="POST" action="/api/auth/logout" name="logout" style="padding: 2px;">');
            // 戻り先を設定（現在のURLのpath部分）
            html.push('<input type="hidden" name="backPath" value="');
            html.push(Locator.getHref().split('?')[0]);
            html.push('">');
            html.push('<a href="javascript:document.logout.submit()">');
            html.push('ログアウト</a></form>');

            // リンク一覧の中身を置き換える
            this.logoutButton.innerHTML = html.join('');

            if (UserInfo.isAuthed()) {
                // 認証済みの場合
                // メニュー用ボタンを表示
                // domStyle.set(this.menuButton, 'display', '');

                if (UserInfo.getLoginMode() === '訓練') {
                    // 訓練
                    domStyle.set(this.disaster, 'display', 'none');
                    domStyle.set(this.training, 'display', '');
                } else {
                    // 実災害
                    domStyle.set(this.disaster, 'display', '');
                    domStyle.set(this.training, 'display', 'none');
                }
                domStyle.set(this.modeArea, 'display', '');

                domStyle.set(this.controlArea, 'display', '');

            }
        },

        // DOMの準備が完了してから呼ばれる
        postCreate: function() {
            this.inherited(arguments);
        },

        startup: function(){
            this.inherited(arguments);

            // デジタルサイネージ更新開始
            this.own(topic.subscribe('app/control/SignageControl::start',
                lang.hitch(this, function () {
                    // ヘッダー切り替え
                    this.toggleHeader();
            })));

        },

        // デジタルサイネージのヘッダーを表示
        toggleHeader: function() {
            // TODO index.htmlの要素をdom.byIdによる指定でスタイル設定しているが処理を変更したい
            domStyle.set(dom.byId("index-Header"), "display", 'none');
            domStyle.set(dom.byId("index-Signage-Header"), "display", '');
            domStyle.set(dom.byId("index-Signage-Header"), "height", 'calc(var(--index-Header-height)/2)');
            domStyle.set(dom.byId("container"), "padding-top", 'calc(var(--index-Header-height)/2)');
            domStyle.set(dom.byId("container"), "background-color", '#eeeeee');
        },

        /**
         * タイトル文字列がクリックされた際に呼ばれ、トップ画面へ遷移させる。
         * @param {MouseEvent} evt クリック・イベント
         */
        onTitleLinkClick: function(evt) {
            // ブラウザーの遷移処理をキャンセル
            evt.preventDefault();
            // トップ画面以外にいる場合はトップ画面へ遷移
            if (Locator.getQuery().p) {
                // ページへ遷移
                Locator.pushState('?', true);
            }
        }

    });
});
